<template>
  <span class="column-formatter">
    {{ formatFieldValue() }}
  </span>
</template>

<script>
import { Decimal } from 'decimal.js'
export default {
  name: 'columnFormatter',
  inject: ['structure', 'attribute'],
  props: {
    // 表单对象
    formData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 表单内的组件对象
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    structureList() {
      return this.structure()
    },
    bindWidgets() {
      const arr = []
      arr.push({
        id: this.item.id,
        name: this.item.name,
        value: this.formData[this.item.id]
      })
      return arr
    },
    // 一控件对应多个字段
    // 时间 滑块
    formatterValue: {
      get() {
        if (this.item.props.range || (this.item.props.datetype && this.item.props.datetype.indexOf('range') !== -1)) {
          const value = this.bindWidgets.map(s => {
            return s.value
          })
          return value.join('-')
        } else {
          return this.formData[this.item.id]
        }
      }
    }
  },
  methods: {
    normal(cellValue) {
      return cellValue === '1900/01/01 00:00' ? '' : cellValue
    },
    dateFormat(date, fmt) {
      var o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds() // 毫秒
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt
    },
    formatFieldValue() {
      const row = JSON.parse(JSON.stringify(this.formData))
      const columnInfo = this.item
      var rowData = row[columnInfo.id]
      if (!rowData) {
        if (columnInfo.baseType === 3) {
          if (this.attribute.zero) {
            rowData = 0
          } else {
            return ''
          }
        } else {
          return ''
        }
      }
      try {
        switch (columnInfo.baseType) {
          case 3:
            var length = columnInfo.dispScale === 0 ? 0 : (columnInfo.dispScale || 0)
            rowData = new Decimal(rowData)
            switch (columnInfo.dataType) {
              case 301:
                // 整数
                return rowData.truncated().toNumber()
              case 302:
                // 小数
                return this.numberCover(rowData.toDP(length).toNumber(), length)
              // case 303:
              //   // 数值去尾
              //   return rowData.toNumber()
              case 304:
                // 百分比小数
                return this.numberCover(rowData.times(100).toDP(length).toNumber(), length) + '%'
              // case 305:
              //   // 无限小数百分比
              //   return rowData.times(100).toDP(8).toNumber() + '%'
              case 306:
                // 人民币金额
                return '￥' + this.numberCover(rowData.toDP(length).toNumber(), length)
              case 307:
                // 美元金额
                return '$' + this.numberCover(rowData.toDP(length).toNumber(), length)
              case 308:
                return this.numberCover(this.numberThousands(rowData.toDP(length).toNumber()), length)
              default:
                // 数值去尾
                return this.numberCover(rowData.toNumber(), length)
            }
          case 4:
            try {
              if (rowData === '1900/01/01 00:00') {
                return ''
              }
              var dateTime = new Date(rowData)
              switch (columnInfo.dataType) {
                case 401:
                  // 2019
                  return this.dateFormat(dateTime, 'yyyy')
                case 402:
                  // 2019年
                  return this.dateFormat(dateTime, 'yyyy年')
                case 403:
                  // 2019-1
                  return this.dateFormat(dateTime, 'yyyy-M')
                case 421:
                  // 2019-1
                  return this.dateFormat(dateTime, 'yyyy-MM')
                case 404:
                  // 2019/1
                  return this.dateFormat(dateTime, 'yyyy/M')
                case 422:
                  // 2019/1
                  return this.dateFormat(dateTime, 'yyyy/MM')
                case 405:
                  // 2019年1月
                  return this.dateFormat(dateTime, 'yyyy年M月')
                case 423:
                  // 2019年1月
                  return this.dateFormat(dateTime, 'yyyy年MM月')
                case 412:
                  // 1月
                  return this.dateFormat(dateTime, 'M月')
                case 406:
                  // 2019-1-1
                  return this.dateFormat(dateTime, 'yyyy-M-d')
                case 424:
                  // 2019-1-1
                  return this.dateFormat(dateTime, 'yyyy-MM-dd')
                case 407:
                  // 2019/1/1
                  return this.dateFormat(dateTime, 'yyyy/M/d')
                case 425:
                  // 2019/1/1
                  return this.dateFormat(dateTime, 'yyyy/MM/dd')
                case 408:
                  // 2019年1月1日
                  return this.dateFormat(dateTime, 'yyyy年M月d日')
                case 426:
                  // 2019年1月1日
                  return this.dateFormat(dateTime, 'yyyy年MM月dd日')
                case 413:
                  // 1-1
                  return this.dateFormat(dateTime, 'M-d')
                case 427:
                  // 1-1
                  return this.dateFormat(dateTime, 'MM-dd')
                case 414:
                  // 1/1
                  return this.dateFormat(dateTime, 'M/d')
                case 428:
                  // 1/1
                  return this.dateFormat(dateTime, 'MM/dd')
                case 415:
                  // 1月1日
                  return this.dateFormat(dateTime, 'M月d日')
                case 429:
                  // 1月1日
                  return this.dateFormat(dateTime, 'MM月dd日')
                case 409:
                  // 2019-1-1 1:01:01
                  return this.dateFormat(dateTime, 'yyyy-M-d h:mm:ss')
                case 430:
                  // 2019-1-1 1:01:01
                  return this.dateFormat(dateTime, 'yyyy-MM-dd h:mm:ss')
                case 410:
                  // 2019/1/1 1:01:01
                  return this.dateFormat(dateTime, 'yyyy/M/d h:mm:ss')
                case 431:
                  // 2019/1/1 1:01:01
                  return this.dateFormat(dateTime, 'yyyy/MM/dd h:mm:ss')
                case 411:
                  // 2019年1月1日 1时01分01秒
                  return this.dateFormat(dateTime, 'yyyy年M月d日 h时mm分ss秒')
                case 432:
                  // 2019年1月1日 1时01分01秒
                  return this.dateFormat(dateTime, 'yyyy年MM月dd日 h时mm分ss秒')
                case 416:
                  // 1:01
                  return this.dateFormat(dateTime, 'h:mm')
                case 417:
                  // 1时01分
                  return this.dateFormat(dateTime, 'h时mm分')
                case 418:
                  // 1:01:01
                  return this.dateFormat(dateTime, 'h:mm:ss')
                case 419:
                  // 1时01分01秒
                  return this.dateFormat(dateTime, 'h时mm分ss秒')
                default:
                  if (dateTime.getHours() + dateTime.getMinutes() + dateTime.getSeconds()) {
                    return this.dateFormat(dateTime, 'yyyy-M-d h:mm:ss')
                  } else {
                    return this.dateFormat(dateTime, 'yyyy-M-d')
                  }
              }
            } catch (ex) {
              return rowData
            }
          case 1:
          case 5:
          case 6:
          default:
            return rowData
        }
      } catch (exp) {
        console.log(exp)
        console.error('转换失败！')
        return rowData
      }
    },
    numberThousands(number) {
      if (number) {
        var str = number.toString()
        var leftSide = str
        var hasDecimal = false
        if (str.indexOf('.') >= 0) {
          leftSide = str.split('.')[0]
          hasDecimal = true
        }
        var length = leftSide.length
        for (var i = 0; i < length; i++) {
          if ((i + 1) % 3 === 0 && length - i - 1 > 0) {
            leftSide = leftSide.slice(0, length - i - 1) + ',' + leftSide.slice(length - i - 1)
          }
        }
        if (hasDecimal) {
          return leftSide + '.' + str.split('.')[1]
        } else {
          return leftSide
        }
      } else {
        return str
      }
    },
    numberCover(number, length) {
      if (length > 0) {
        number = (number || 0).toString()
        const splitEle = number.split('.')
        if (splitEle.length === 1) {
          splitEle.push('')
        }
        splitEle[1] += '0'.repeat(length)
        return splitEle[0] + '.' + splitEle[1].substring(0, length)
      } else {
        return (number || 0).toString()
      }
    }
  }
}
</script>